import * as React from 'react';
import { Field } from 'redux-form/';

const asFormField = () => <OriginalProps extends {}>(WrappedComponent: React.ComponentType<OriginalProps>) => {
  return (props: any) => {
    return <Field component={WrappedComponent} {...props} />;
  };
};

export default asFormField;



// WEBPACK FOOTER //
// ./src/components/Form/asFormField.tsx